import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { Link } from 'react-router-dom';

import { PUBLIC_SITE_URL } from 'utils/restapi';

import ChangeUsername from 'components/dashboard/settings-content/ChangeUsername';
import MyAccount from 'components/dashboard/common/MyAccount';
import CommonUnlockProBtn from 'components/dashboard/common/CommonUnlockProBtn';
import CommonMessage from 'components/common/CommonMessage';
import LanguageSwitcher from 'components/common/LanguageSwitcher';

import './DashboardHeader.css';
import {connect} from "react-redux";
import { resendEmailConfirmation } from 'redux/users/actions';
import { setLang } from 'redux/users/actions';


class DashboardHeader extends Component {
  static propTypes = {
    me: PropTypes.object,
    resendEmailConfirmation: PropTypes.func.isRequired,
    setLang: PropTypes.func.isRequired,
    confirmationResentError: PropTypes.object,
  };

  static defaultProps = {
    me: null,
    confirmationResentError: null,
  };

  state = {
    seconds: 0,
    resend: false,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.seconds !== this.state.seconds && this.state.seconds > 0) {
      setTimeout(() => {
        this.setState({ seconds: this.state.seconds - 1 });
      }, 1000);
    }
  }

  render() {
    const {
      me,
      confirmationResentError,
      resendEmailConfirmation,
      setLang,
    } = this.props;
    return (
      <Translation>
        {(t) => (
          <div className="dashboard-header__component">

            {me && !me.email_is_verified &&
              <div className="verification-message">
                <CommonMessage warning>
                  {!this.state.resend ?
                    <div className="red-text">
                      {t("To confirm & verify your profile, please click on the link we have sent to")} ({me.email}).<br/>
                      {t("If you still can't verify your email after a few attempts, please send an email to")} <a href="mailto:team@heylink.me">team@heylink.me</a>
                    </div>
                    :
                    <div className="black-text">
                      {t("Thank you! We have resent a confirmation email. Please check your Inbox.")}<br/>
                      {t("If you still can't verify your email after a few attempts, please send an email to")} <a href="mailto:team@heylink.me">team@heylink.me</a>
                    </div>
                  }

                  <div>
                    {this.state.seconds > 0 ?
                      <div className="wait-text">
                        {t("Please, wait... You'll be able to resend email in")} <strong>{this.state.seconds}</strong> {t("seconds")}
                      </div>
                      :
                      <a
                        className="resend"
                        onClick={() => {
                          resendEmailConfirmation(me.email);
                          this.setState({
                            seconds: 20,
                            resend: true,
                          });
                        }}
                      >
                        {t("Resend Confirmation Email")}
                      </a>
                    }
                  </div>

                  <div>
                    <Link to="/security">{t("Change Email")}</Link>
                  </div>

                  {/* Resend Error */}
                  {confirmationResentError &&
                    <CommonMessage
                      error
                      errors={confirmationResentError}
                    />
                  }
                </CommonMessage>
              </div>
            }

            {me && me.is_banned &&
              <div className="verification-message">
                <CommonMessage warning>
                  <div className="red-text">
                    {t("This account needs to be verified by HeyLink.me. " +
                       "In some cases, we need to conduct a manual verification " +
                       "to support Google's initiative to enable a free and open web.")}
                    {t("Please check our")} <a href={`${PUBLIC_SITE_URL}/terms/`} target='blank'>{t("Terms & Policies")}</a> {t("for more details")}.
                  </div>
                </CommonMessage>
              </div>
            }

            <div className="main-container">
              <a className="logo" href={`${PUBLIC_SITE_URL}`}>
                <div className="logo-icon">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0"
                       viewBox="0 0 43.9 43.9">
                    <path fill="#48d6d5" className="st0"
                          d="M34.6 9.3l7.1 7.1c2.5 2.5 2.5 6.6 0 9.2-.4.4-.7.8-1.1 1.1-1.3 1.2-3.3 1.2-4.5-.1-.9-.9-1.2-2.2-.8-3.4.2-.5.2-.4.5-1.2.4-.9.2-2.1-.6-2.8l-5.3-5.3-5.3-5.3c-.8-.8-1.9-.9-2.8-.6-.8.3-.7.3-1.2.5-1.1.4-2.5.2-3.4-.8-1.2-1.2-1.3-3.2-.1-4.5l1.1-1.1c2.5-2.5 6.6-2.5 9.2 0l7.2 7.2zM13.9 30.1l-5.3-5.3c-.7-.7-.9-1.8-.6-2.7.1-.3.4-1 .5-1.2.5-1.2.2-2.5-.7-3.5-1.2-1.2-3.2-1.3-4.5-.1l-1.1 1.1c-2.5 2.5-2.5 6.6 0 9.2l7.1 7.1 7.1 7.1c2.5 2.5 6.6 2.5 9.2 0 .4-.4.8-.7 1.1-1.1 1.2-1.3 1.2-3.3-.1-4.5-.9-.9-2.3-1.2-3.5-.7-.3.1-.9.4-1.2.5-.9.3-2 .1-2.7-.6l-5.3-5.3zM33.5 39.1c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-8.4-8.4c-1.5-1.5-4-1.5-5.5 0s-1.5 4 0 5.5c4.3 4.3 4.1 4 8.4 8.4zM13.3 18.8c1.5 1.5 4 1.5 5.5 0s1.5-4 0-5.5l-8.4-8.4c-1.5-1.5-4-1.5-5.5 0s-1.5 4 0 5.5c4.3 4.3 4 4.1 8.4 8.4z"/>
                  </svg>
                </div>
                <div>HeyLink.me</div>
              </a>
              <ChangeUsername/>
              <CommonUnlockProBtn className="main-top-menu"/>
              <LanguageSwitcher onChange={setLang} />
              <MyAccount/>
            </div>

            {/* <MobileViewLive /> */}
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    confirmationResentError: state.usersReducer.confirmationResentError,
  }
);

export default connect(
  mapStateToProps,
  {
    resendEmailConfirmation,
    setLang,
  }
)(DashboardHeader);

